import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes',
)({
  component: QuizzesLayout,
});

function QuizzesLayout() {
  return <Outlet />;
}
